export default __webpack_public_path__ + "img/cb1d42364efc83750db929e8aa1b5b6b.png";